import { AnyAction } from 'redux'

type KeyValueState<T> = { [key: string]: T }
export function keyValueUpdateReducer<T>(
  state: KeyValueState<T>,
  id: string,
  value: Partial<T>,
): KeyValueState<T> {
  return {
    ...state,
    [id]: {
      ...state[id],
      ...value,
    },
  }
}

export function keyValueSetReducer<T>(
  state: KeyValueState<T>,
  id: string,
  value: T,
): KeyValueState<T> {
  return {
    ...state,
    [id]: value,
  }
}
type FunctionWithString<T extends Function> = T & string
interface ActionWithPayload<T = any> extends AnyAction {
  payload: T
}
// We need to trick typescript into thinking our actions are strings for switch to work
type ActionCreator<T = any> = FunctionWithString<(payload: T) => ActionWithPayload<T>>

export function createPayloadAction<T>(name: string): ActionCreator<T> {
  const actionCreator = (payload: T) => ({
    type: name,
    payload,
  })
  actionCreator.toString = () => name
  return actionCreator as any as ActionCreator<T>
}

type FsReducer<S, A = any> = (state: S, payload: A) => S

interface ReducersMap<S> {
  [key: string]: FsReducer<S>
}

export function createReducer<S>(reducers: ReducersMap<S>, defaultState: S) {
  return (state: S, action: ActionWithPayload) => {
    if (!state) {
      return defaultState
    }
    const reducer = reducers[action.type]

    if (reducer) {
      return reducer(state, action.payload)
    }

    return state
  }
}
